var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodGreat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_radial_40_49592)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2727 17.6313C17.2727 19.6494 15.6363 21.2858 13.6182 21.2858C11.6 21.2858 9.96362 19.6494 9.96362 17.6313C9.96362 15.6131 11.6 13.9767 13.6182 13.9767C15.6545 13.9585 17.2727 15.6131 17.2727 17.6313Z",
    fill: "#F96ABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0181 17.1956C18.0181 19.2137 16.3817 20.8501 14.3635 20.8501C12.3453 20.8501 10.709 19.2137 10.709 17.1956C10.709 15.1774 12.3453 13.541 14.3635 13.541C16.3817 13.541 18.0181 15.1774 18.0181 17.1956Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0181 17.1962C16.0181 18.1234 15.2726 18.8689 14.3635 18.8689C13.4544 18.8689 12.709 18.1234 12.709 17.1962C12.709 16.2689 13.4544 15.5234 14.3635 15.5234C15.2726 15.5416 16.0181 16.2871 16.0181 17.1962Z",
    fill: "#14110E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7453 16.4511C13.7453 16.8693 13.3998 17.2148 12.9817 17.2148C12.5635 17.2148 12.218 16.8693 12.218 16.4511C12.218 16.033 12.5635 15.6875 12.9817 15.6875C13.3998 15.6875 13.7453 16.0148 13.7453 16.4511Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4365 17.6313C29.4365 19.6494 27.8002 21.2858 25.782 21.2858C23.7638 21.2858 22.1274 19.6494 22.1274 17.6313C22.1274 15.6131 23.7638 13.9767 25.782 13.9767C27.8002 13.9585 29.4365 15.6131 29.4365 17.6313Z",
    fill: "#F96ABA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1638 17.1956C30.1638 19.2137 28.5275 20.8501 26.5093 20.8501C24.4911 20.8501 22.8547 19.2137 22.8547 17.1956C22.8547 15.1774 24.4911 13.541 26.5093 13.541C28.5275 13.541 30.1638 15.1774 30.1638 17.1956Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.291 17.196C28.291 18.1415 27.5274 18.9233 26.5819 18.9233C25.6364 18.9233 24.8728 18.1597 24.8728 17.196C24.8728 16.2506 25.6364 15.4688 26.5819 15.4688C27.5274 15.4869 28.291 16.2506 28.291 17.196Z",
    fill: "#14110E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9274 16.4146C25.9274 16.851 25.5819 17.1964 25.1456 17.1964C24.7092 17.1964 24.3638 16.851 24.3638 16.4146C24.3638 15.9783 24.7092 15.6328 25.1456 15.6328C25.5819 15.6328 25.9274 15.9783 25.9274 16.4146Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8364 25.0871C14.8364 27.3053 13.0364 29.1235 10.8182 29.1235C8.60005 29.1235 6.80005 27.3235 6.80005 25.0871C6.80005 22.869 8.60005 21.0508 10.8182 21.0508C13.0364 21.0508 14.8364 22.8508 14.8364 25.0871Z",
    fill: "url(#paint1_radial_40_49592)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3818 25.0871C33.3818 27.3053 31.5818 29.1235 29.3636 29.1235C27.1455 29.1235 25.3455 27.3235 25.3455 25.0871C25.3455 22.869 27.1455 21.0508 29.3636 21.0508C31.5818 21.0508 33.3818 22.8508 33.3818 25.0871Z",
    fill: "url(#paint2_radial_40_49592)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3092 12.397C14.9092 11.3061 12.8547 11.1789 11.6729 12.6698C11.4183 12.9789 11.8911 13.397 12.1456 13.088C13.1092 11.8698 14.7638 11.9789 15.8911 12.8698C16.2183 13.1061 16.6365 12.6516 16.3092 12.397Z",
    fill: "#F96ABA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7819 11.9244C15.3819 10.8335 13.3273 10.7062 12.1455 12.1971C11.891 12.5062 12.3637 12.9244 12.6183 12.6153C13.5819 11.3971 15.2364 11.5062 16.3637 12.3971C16.691 12.6335 17.1092 12.1789 16.7819 11.9244Z",
    fill: "#3B0523"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2184 12.397C26.8184 11.3061 24.7639 11.1789 23.5821 12.6698C23.3275 12.9789 23.8002 13.397 24.0548 13.088C25.0184 11.8698 26.673 11.9789 27.8002 12.8698C28.1275 13.1061 28.5457 12.6516 28.2184 12.397Z",
    fill: "#F96ABA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6911 11.9244C27.2911 10.8335 25.2365 10.7062 24.0547 12.1971C23.8002 12.5062 24.2729 12.9244 24.5274 12.6153C25.4911 11.3971 27.1456 11.5062 28.2729 12.3971C28.6002 12.6335 29.0183 12.1789 28.6911 11.9244Z",
    fill: "#3B0523"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4545 24.3457C26.4545 24.3457 20.6181 24.7821 14.0727 24.3457C14.0727 24.3457 12.9272 30.673 20.0181 30.673C27.2727 30.673 26.4545 24.3457 26.4545 24.3457Z",
    fill: "#14110E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9091 24.3828C25.8545 25.001 25.7818 25.6192 25.6909 26.2374C23.7273 26.4919 19.9091 26.801 15.2364 26.2555C15.1273 25.6374 15.0364 25.0192 14.9636 24.401C19.9636 24.6737 24.3818 24.4737 25.9091 24.3828Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9092 28.5088C20.8728 26.7633 23.8183 28.4361 24.7637 29.1633C23.8001 30.0361 22.3092 30.6724 20.0183 30.6724C17.2364 30.6724 15.7274 29.6906 14.9092 28.5088Z",
    fill: "#FC2727"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.418 30.6552C19.2544 30.6552 19.1089 30.637 18.9453 30.6188C19.1453 29.6552 19.4362 28.6915 19.7453 27.7461C19.9089 27.7461 20.0726 27.7461 20.2362 27.7643C19.9271 28.7097 19.618 29.6734 19.418 30.6552Z",
    fill: "#D82525"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40_49592",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.487641,
    stopColor: "#FAA6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E62490"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_40_49592",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8214 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F96ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#F96ABA",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#F96ABA",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#F96ABA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#F96ABA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_40_49592",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3668 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F96ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#F96ABA",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#F96ABA",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#F96ABA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#F96ABA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodGreat);
export default __webpack_public_path__ + "static/media/Mood_Great.29f4a105903a4e92005c8ec1f32b135e.svg";
export { ForwardRef as ReactComponent };